import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { useAuthStore } from '@/store/auth.store';

interface LegalHoldStatus {
  active: boolean;
  count: number;
}

export function useLegalHoldStatus() {
  const { tenantId, isAuthenticated } = useAuthStore();

  return useQuery({
    queryKey: ['legal-hold-status', tenantId],
    queryFn: async () => {
      const { data } = await apiClient.get<{ data: LegalHoldStatus }>('/tenant/legal-hold-status');
      return data.data;
    },
    enabled: isAuthenticated,
    staleTime: 5 * 60_000,
    gcTime: 10 * 60_000,
    // Fail-safe: if endpoint not yet deployed, suppress banner rather than hard error
    retry: false,
  });
}
